import logo from 'assets/images/logo.svg';
import PropTypes from 'prop-types';
const Logo = ({ sx = {} }) => {
    return <img src={logo} alt="Efetivo Web" width="150" {...sx} />;
};

Logo.propTypes = {
    sx: PropTypes.object
};

export default Logo;
